<template>
  <div class="success">
    <h1>Success!</h1>
    <router-link
      tag="button"
      to="/"
      class="button-gemnote button-gemnote--medium"
      >Go to dashboard</router-link
    >
  </div>
</template>

<script>
import { layouts } from '../helpers'

export default {
  name: 'SuccessOnBoardFlow',
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.DEFAULT_LAYOUT)
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.success {
  display: flex;
  flex-direction: column;
  margin-top: 12rem;
  height: 100vh;
  align-items: center;
}
</style>
